import { React, useState, useRef } from "react";
import ContactPopup from "./ContactPopup";
// import "./NGORegistration.css";
import "./PrivateLimitedCompany.css";

const NGORegistration = () => {

  const [openPopup, setOpenPopup] = useState(false);
  const contactRef = useRef(null);
  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="page">

      {/* HERO */}
      <div className="hero">

        <h1>NGO Registration Services</h1>

        <p className="subtitle">
          Start Your NGO & Create Real Impact
        </p>

        <p className="desc">
          Register Your Non-Profit Organization Easily & Legally. We help individuals, groups, and organizations register their NGO with complete legal support—so you can focus on your mission while we handle the compliance.
        </p>

        <div className="badges">
          <span>✔ End-to-End NGO Registration</span>
          <span>✔ Expert Legal Guidance</span>
          <span>✔ Quick & Hassle-Free Process</span>
          <span>✔ Affordable Pricing</span>
        </div>

        <div className="hero-action">
          <button className="hero-btn" onClick={scrollToContact}>
            Get Started Today
          </button>
        </div>

      </div>

      {/* WHAT IS NGO */}
      <div className="section">
        <h2>What is an NGO?</h2>
        <p>
          A Non-Governmental Organization (NGO) is a non-profit entity formed to promote social welfare, charity, education, environment, and other public causes. NGOs in India can be registered under different legal structures.
        </p>
      </div>

      {/* TYPES */}
      <div className="section">
        <h2>Types of NGO Registration in India</h2>

        <h3>1. Trust Registration</h3>
        <p>Governed by Indian Trusts Act. Ideal for charitable activities. Easy to form with trustees.</p>

        <h3>2. Society Registration</h3>
        <p>Governed by Societies Registration Act, 1860. Requires minimum 7 members. Suitable for associations and community groups.</p>

        <h3>3. Section 8 Company</h3>
        <p>Governed by Companies Act, 2013. Higher credibility and transparency. Best for large NGOs and funding opportunities.</p>
      </div>

      {/* BENEFITS */}
      <div className="section">
        <h2>Benefits of NGO Registration</h2>
        <ul>
          <li>Legal recognition</li>
          <li>Eligibility for government grants</li>
          <li>Tax exemptions (12A & 80G)</li>
          <li>Increased credibility and trust</li>
          <li>Ability to open bank account in NGO name</li>
          <li>Separate legal identity</li>
        </ul>
      </div>

      {/* SERVICES */}
      <div className="section">
        <h2>Our NGO Services Include</h2>
        <ul>
          <li>Consultation to choose structure</li>
          <li>Name approval guidance</li>
          <li>Trust Deed / MOA Drafting</li>
          <li>Documentation & Filing</li>
          <li>Registration Certificate</li>
          <li>PAN & TAN Application</li>
          <li>12A & 80G Assistance</li>
          <li>CSR-1 Registration</li>
        </ul>
      </div>

      {/* DOCUMENTS */}
      <div className="section">
        <h2>Documents Required</h2>

        <h3>For Members/Trustees/Directors:</h3>
        <ul>
          <li>PAN Card</li>
          <li>Aadhaar / Passport / Voter ID</li>
          <li>Passport-size Photograph</li>
          <li>Address Proof</li>
        </ul>

        <h3>For Registered Office:</h3>
        <ul>
          <li>Rent Agreement (if rented)</li>
          <li>NOC from Owner</li>
          <li>Utility Bill</li>
        </ul>
      </div>

      {/* PROCESS */}
      <div className="section">
        <h2>Registration Process</h2>
        <ul>
          <li>Consultation – Choose NGO structure</li>
          <li>Document Preparation – Draft deed/MOA</li>
          <li>Filing Application – Submit documents</li>
          <li>Verification – Government review</li>
          <li>Approval – Get registration certificate</li>
        </ul>
      </div>

      {/* PRICING */}
      <div className="section">
        <h2>Pricing Plans</h2>

        <div className="grid">

          <div className="card blue">
            <h3>Basic Plan</h3>
            <ul>
              <li>NGO Consultation</li>
              <li>Document Drafting</li>
            </ul>
          </div>

          <div className="card purple">
            <h3>Standard Plan</h3>
            <ul>
              <li>Registration (Trust/Society/Section 8)</li>
              <li>PAN Application</li>
            </ul>
          </div>

          <div className="card orange">
            <h3>Premium Plan</h3>
            <ul>
              <li>Registration + 12A & 80G</li>
              <li>CSR-1 Assistance</li>
              <li>Compliance Support</li>
            </ul>
          </div>

        </div>
      </div>

      {/* WHY US */}
      <div className="section">
        <h2>Why Choose Us?</h2>
        <ul>
          <li>NGO Registration Experts</li>
          <li>Transparent Pricing</li>
          <li>Fast Processing</li>
          <li>Dedicated Support</li>
          <li>Complete Legal Assistance</li>
        </ul>
      </div>

      {/* FAQ */}
      <div className="section">
        <h2>FAQs</h2>

        <p><b>Which is better?</b> Section 8 offers higher credibility, Trust/Society are easier.</p>
        <p><b>Can NGOs earn income?</b> Yes, but must be used for social objectives.</p>
        <p><b>Is 12A & 80G mandatory?</b> Not mandatory but recommended.</p>
        <p><b>How long does it take?</b> 10–20 working days.</p>
      </div>

      {/* CTA */}
      <div className="cta" ref={contactRef} >
        <h2>Ready to Start Your NGO?</h2>
        <p>Make a difference with a legally registered organization.</p>

        <div className="cta-buttons">
          <button onClick={() => setOpenPopup(true)}
          >Contact Us Now</button>
          <ContactPopup
            isOpen={openPopup}
            onClose={() => setOpenPopup(false)}
          />


          <button className="outline"
            onClick={() => window.location.href = "tel:9218103915"}
          >Free Consultation</button>
        </div>
      </div>

    </div>
  );
};

export default NGORegistration;